module.exports = __webpack_public_path__ + "img/third_ye.3ead6180.png";